import {useEffect} from "react";
import {useRouter} from "../../routes/hooks";
import {getServerName} from "../../utils/serverName";

type Props = {
  children: React.ReactNode;
};

export function MatematicoGuard({ children }: Props) {
  const router = useRouter();

  useEffect(() => {
    if (getServerName() !== 'Matematico') {
      router.replace('/');
    }
  }, [router]);

  return <>{children}</>;
}

export function ExamicoGuard({ children }: Props) {
  const router = useRouter();

  useEffect(() => {
    if (getServerName() !== 'Examico') {
      router.replace('/');
    }
  }, [router]);

  return <>{children}</>;
}
